import styled from 'styled-components';

export const StyledAppLoadingSpinner = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.backgound};
`;

export const StyledSpinner = styled.img`
  width: 32rem;
  max-height: 80vh;
  max-width: 80vw;
`;
